import { readFile } from "fs/promises";
import "path";
import { o as objectValuesWithId } from "../../../../chunks/objectValuesWithId.js";
function removeKey(obj, keysToRemove) {
  for (const prop in obj) {
    if (keysToRemove.includes(prop)) {
      delete obj[prop];
    } else if (typeof obj[prop] === "object") {
      removeKey(obj[prop], keysToRemove);
    } else
      ;
  }
}
const prerender = true;
const filePath = "src/_games.json";
const teamsPath = "src/teams.json";
const teams = JSON.parse(await readFile(teamsPath, "utf8"));
const games = JSON.parse(await readFile(filePath, "utf8"));
async function load({ fetch, params }) {
  const team = teams[
    // (await read("/" + path.resolve("./") + "/" + teamsPath).json())
    params.id
  ] ?? await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/teams/${params.id}.json`
    // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/players.json" +
    //   "?orderBy=%22teamid%22&equalTo=%22" +
    //   params.id +
    //   "%22"
  )).json();
  const data = objectValuesWithId(games).filter(
    (v, i, l) => v.homeid == params.id || v.awayid == params.id
  ) || objectValuesWithId(
    ...await (await fetch(
      // `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/teams/${params.id}.json`
      "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderBy=%22homeid%22&equalTo=%22" + params.id + "%22"
    )).json(),
    ...await (await fetch(
      // `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/teams/${params.id}.json`
      "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderBy=%22awayid%22&equalTo=%22" + params.id + "%22"
    )).json()
  );
  const fixtures = data;
  removeKey(fixtures, [
    "events",
    "fouls",
    "injurys",
    "corners",
    "shots",
    "offsides",
    "yellowcards",
    "home_lineup",
    "away_lineup",
    "home_substitutes",
    "away_substitutes"
  ]);
  return {
    team,
    // fixtures: [ ...data, ...data2 ],
    fixtures
  };
}
export {
  load,
  prerender
};
